var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrategicAr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_108_622)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1255 46.5293H115.916C115.966 46.9684 116.041 47.3699 116.041 47.7588C116.041 51.8864 116.079 56.0141 116.016 60.1417C116.016 60.7816 115.703 61.6347 115.226 62.0111C112.064 64.6081 110.521 67.9579 109.806 71.935C108.89 77.0161 107.585 82.0219 106.543 87.0905C105.715 91.1052 108.865 94.2417 112.88 93.5141C113.858 93.3384 114.824 93.1252 115.928 92.8993V153.471H25.1255V46.5293ZM100.006 89.3363C100.006 85.0455 100.044 80.7548 100.006 76.4766C99.9686 73.177 98.5383 70.58 95.6023 69.0494C88.4756 65.3358 81.2986 61.6849 74.1217 58.0716C71.7378 56.8672 69.266 56.9174 66.8695 58.1218C59.8432 61.6974 52.8294 65.2981 45.8156 68.8863C42.6663 70.4922 41.123 73.1268 41.0979 76.6021C41.0602 85.0706 41.0602 93.5392 41.0979 102.008C41.0979 105.571 42.7415 108.18 45.941 109.811C52.8294 113.324 59.7052 116.837 66.5809 120.375C69.2409 121.743 71.8883 121.743 74.5358 120.375C81.4116 116.85 88.2873 113.337 95.1757 109.824C98.5006 108.13 100.056 105.42 100.019 101.719C99.9812 97.5915 100.019 93.4639 100.019 89.3237L100.006 89.3363ZM70.596 137.739C71.9887 137.262 73.4944 136.948 74.8118 136.271C84.059 131.528 93.256 126.711 102.466 121.918C103.018 121.63 103.595 121.354 104.109 121.002C105.314 120.174 105.665 118.782 105.025 117.565C104.385 116.335 103.043 115.821 101.7 116.323C101.261 116.486 100.847 116.724 100.433 116.937C91.1732 121.755 81.9009 126.56 72.6663 131.416C71.1606 132.206 69.8808 132.193 68.4003 131.378C65.1506 129.596 61.8382 127.928 58.5508 126.222C52.4404 123.035 46.3175 119.873 40.2196 116.674C38.8896 115.971 37.6349 115.796 36.4931 116.95C35.1004 118.368 35.6274 120.312 37.6976 121.391C47.3714 126.435 57.0452 131.491 66.7441 136.484C67.8733 137.061 69.1907 137.287 70.596 137.739Z",
    fill: "url(#paint0_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0251 159.029H115.929C115.929 162.229 116.192 165.378 115.853 168.451C115.452 172.077 112.139 174.749 108.463 174.975C107.936 175.013 107.422 175 106.895 175C82.6287 175 58.3752 175 34.1092 175C28.2246 175 25.0251 171.789 25.0251 165.879C25.0251 163.646 25.0251 161.4 25.0251 159.029ZM70.5709 164.299C68.9524 164.299 67.3338 164.299 65.7027 164.299C65.6023 164.299 65.4894 164.299 65.389 164.299C63.6324 164.374 62.5408 165.403 62.5534 166.971C62.5534 168.476 63.6199 169.593 65.2635 169.618C68.7642 169.681 72.2648 169.681 75.778 169.618C77.4718 169.593 78.6387 168.351 78.576 166.858C78.5132 165.403 77.384 164.349 75.7529 164.311C74.0339 164.274 72.3024 164.311 70.5709 164.299Z",
    fill: "url(#paint1_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0377 40.9961C25.0377 38.0729 24.9248 35.3003 25.0754 32.5401C25.2761 28.5129 28.576 25.3262 32.6036 25.0753C33.1306 25.0376 33.645 25.0502 34.172 25.0502C58.438 25.0502 82.6914 25.1254 106.957 24.9874C112.114 24.9623 116.43 28.4376 116.054 34.146C115.903 36.3792 116.029 38.6249 116.029 40.971H25.0377V40.9961ZM63.7454 35.7519C65.0503 35.7519 66.3552 35.7519 67.6601 35.7519C67.7604 35.7519 67.8734 35.7519 67.9737 35.7519C69.4417 35.6139 70.433 34.6479 70.5082 33.2553C70.5835 31.825 69.6049 30.5328 68.1118 30.47C65.2887 30.3571 62.4656 30.3697 59.6425 30.47C58.1243 30.5202 57.1456 31.7623 57.1833 33.1925C57.2335 34.6353 58.2623 35.6766 59.8181 35.7394C61.123 35.7895 62.4279 35.7394 63.7328 35.7394L63.7454 35.7519ZM79.8432 35.7519C80.3702 35.7519 80.8846 35.7895 81.4116 35.7519C82.8169 35.6265 83.8708 34.56 83.9336 33.2176C83.9963 31.963 83.0804 30.7711 81.7755 30.5202C81.1732 30.3948 80.5333 30.4324 79.906 30.4324C77.246 30.4324 75.916 31.3106 75.8909 33.0922C75.8658 34.8862 77.1833 35.777 79.8432 35.7645V35.7519Z",
    fill: "url(#paint2_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.662 33.8203C153.256 35.4513 155.05 37.2705 156.957 39.2276C156.669 39.5413 156.255 39.9804 155.828 40.407C147.183 49.0512 138.538 57.6954 129.893 66.3521C129.554 66.6908 129.216 67.0045 128.902 67.3558C127.685 68.6731 127.61 70.141 128.676 71.2701C129.78 72.4369 131.361 72.4244 132.691 71.1196C134.824 69.0495 136.92 66.9167 139.015 64.8089C145.891 57.9337 152.766 51.0585 159.642 44.1959C160.044 43.7944 160.458 43.4055 160.809 43.0793C162.691 44.9737 164.523 46.818 166.242 48.5368C155.038 59.7404 143.745 71.0318 132.553 82.2102C127.71 77.3675 122.741 72.3867 117.923 67.5565C129.027 56.4533 140.307 45.1744 151.662 33.8203Z",
    fill: "url(#paint3_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.389 29.3656C156.518 28.274 157.735 27.0445 159.002 25.8903C160.282 24.7235 161.637 24.7235 162.905 25.9656C166.656 29.6667 170.383 33.3928 174.084 37.1441C175.263 38.3485 175.289 39.6909 174.209 40.9204C173.043 42.2503 171.8 43.4923 170.684 44.6717C165.502 39.4776 160.496 34.4718 155.389 29.353V29.3656Z",
    fill: "url(#paint4_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.606 85.02C121.964 86.0487 117.033 87.1277 111.738 88.2945C112.892 83.0753 113.971 78.1197 115.05 73.2393C118.915 77.1662 122.754 81.0931 126.606 85.02Z",
    fill: "url(#paint5_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7477 114.955C63.2308 112.646 58.9146 110.438 54.5984 108.23C52.5031 107.164 50.4202 106.085 48.3123 105.043C47.1831 104.479 46.4554 103.626 46.4554 102.358C46.4303 94.2161 46.4428 86.0612 46.4428 77.7432C46.9573 77.9314 47.3337 78.0192 47.685 78.1948C54.0338 81.369 60.3952 84.5306 66.7189 87.7549C67.2458 88.0183 67.8481 88.7711 67.8481 89.3106C67.9234 97.5658 67.8983 105.834 67.8857 114.089C67.8857 114.29 67.823 114.478 67.7477 114.955Z",
    fill: "url(#paint6_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6487 77.6934C94.6487 80.0018 94.6487 82.1346 94.6487 84.2549C94.6487 90.1139 94.6362 95.9603 94.6487 101.819C94.6487 103.275 94.1468 104.341 92.8419 105.019C86.6061 108.193 80.3827 111.379 74.1468 114.554C73.9335 114.666 73.6826 114.717 73.3187 114.842C73.2811 114.265 73.2309 113.813 73.2309 113.362C73.2309 105.47 73.2435 97.5788 73.2058 89.6873C73.2058 88.6586 73.4944 88.1316 74.448 87.6674C80.7215 84.5937 86.9699 81.4446 93.2184 78.3207C93.6199 78.1199 94.0465 77.9568 94.6362 77.7059L94.6487 77.6934Z",
    fill: "url(#paint7_linear_108_622)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.4292 73.076C50.4079 72.5616 51.0854 72.1978 51.763 71.8465C57.4342 68.9484 63.118 66.0753 68.7768 63.1396C69.9436 62.5374 71.0227 62.4495 72.2021 63.0517C78.4254 66.251 84.6488 69.4251 90.8847 72.6118C91.0603 72.6996 91.2234 72.8251 91.5371 73.0384C91.098 73.3018 90.7843 73.5277 90.433 73.7033C84.1845 76.8398 77.9361 79.9763 71.65 83.0752C71.1231 83.3386 70.2824 83.4641 69.8056 83.2257C63.1055 79.9387 56.443 76.5889 49.4292 73.076Z",
    fill: "url(#paint8_linear_108_622)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_108_622",
    x1: 70.5891,
    y1: 46.5293,
    x2: 70.5891,
    y2: 153.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_108_622",
    x1: 70.5257,
    y1: 159.029,
    x2: 70.5257,
    y2: 175.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_108_622",
    x1: 70.537,
    y1: 24.9873,
    x2: 70.537,
    y2: 40.9961,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_108_622",
    x1: 142.083,
    y1: 33.8203,
    x2: 142.083,
    y2: 82.2102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_108_622",
    x1: 165.192,
    y1: 25.0244,
    x2: 165.192,
    y2: 44.6717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_108_622",
    x1: 119.172,
    y1: 73.2393,
    x2: 119.172,
    y2: 88.2945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_108_622",
    x1: 57.1699,
    y1: 77.7432,
    x2: 57.1699,
    y2: 114.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_108_622",
    x1: 83.9273,
    y1: 77.6934,
    x2: 83.9273,
    y2: 114.842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_108_622",
    x1: 70.4831,
    y1: 62.6416,
    x2: 70.4831,
    y2: 83.3523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_108_622"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategicAr);
export default __webpack_public_path__ + "static/media/Strategic_AR.2e8dae67b5e036705257a1754774fa9b.svg";
export { ForwardRef as ReactComponent };